// extracted by css-extract-rspack-plugin
export default {"issueDetailContainer":"IssueShowPage-module__issueDetailContainer__DbXfA"};